module.exports = __webpack_public_path__ + "static/fonts/Fact-SemiExpandedThin.2dd1dc3.woff";